import { Box } from '@mui/material';
import type { FC, ReactNode } from 'react';

const RightComponentWrapper: FC<{
  children: ReactNode;
  testId?: string;
}> = ({ children, testId }) => (
  <Box
    gap={1}
    maxWidth={200}
    flexDirection="row"
    display="flex"
    alignItems="center"
    data-testid={testId}
  >
    {children}
  </Box>
);

export default RightComponentWrapper;
